(function () {
  function initCarousel(container) {
    // Guarda contra inicialização duplicada (ex.: Theme Editor recarregando a section).
    if (container.dataset.frenesiCarouselInit === 'true') return;
    container.dataset.frenesiCarouselInit = 'true';

    var slides = Array.prototype.slice.call(container.querySelectorAll('.frenesi-promo77-topbar__slide'));
    if (!slides.length) return;

    var current = 0;

    function show(index) {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    show(current);

    if (slides.length < 2) return;

    var timer = window.setInterval(function () {
      // Se a section for removida do DOM (Theme Editor), encerra o intervalo.
      if (!container.isConnected) {
        window.clearInterval(timer);
        return;
      }
      current = (current + 1) % slides.length;
      show(current);
    }, 4000);
  }

  function init() {
    document.querySelectorAll('[data-frenesi-topbar-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
